<template>
  <div class="milestone-page">
    <!-- 顶部操作栏 -->
    <div class="top-header">
      <h2>发展历程</h2>
      <template v-if="isDesktop">
        <el-radio-group v-model="currentLang" @change="handleLangChange">
          <el-radio-button v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="handleAddMilestone">添加</el-button>
      </template>
      <template v-else>
        <van-radio-group v-model="currentLang" @change="handleLangChange">
          <van-radio v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</van-radio>
        </van-radio-group>
        <van-button type="primary" @click="handleAddMilestone">添加</van-button>
      </template>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <div class="intro-card">
        <div class="card-content">
          <template v-if="filteredMilestoneList.length === 0">
            <div class="empty-state">
              <el-empty :description="currentLang === 'zh' ? '暂无发展历程' : currentLang === 'en' ? 'No development milestones' : '발전 이정표가 없습니다'" />
            </div>
          </template>
          <template v-else>
            <el-table :data="filteredMilestoneList" style="width: 100%" v-if="isDesktop">
              <el-table-column prop="date" label="日期" width="180" />
              <el-table-column prop="title" label="标题" width="180" />
              <el-table-column prop="content" label="里程碑" />
              <!-- 添加显示开关 -->
              <el-table-column prop="status" label="显示" width="180">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="隐藏" @change="handleStatusChange(scope.row)" />
                </template>
              </el-table-column>
              
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="handleEditMilestone(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="handleDeleteMilestone(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="mobile-milestone-list">
              <div v-for="item in filteredMilestoneList" :key="item.id" class="mobile-milestone-item">
                <div class="mobile-milestone-date">{{ item.date }}</div>
                <div class="mobile-milestone-content">{{ item.content }}</div>
                <div class="mobile-milestone-actions">
                  <van-button size="small" type="primary" @click="handleEditMilestone(item)">编辑</van-button>
                  <van-button size="small" type="danger" @click="handleDeleteMilestone(item.id)">删除</van-button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    
    <!-- 添加/编辑发展历程对话框 -->
    <template v-if="isDesktop">
      <el-dialog
        :title="milestoneDialogTitle"
        :visible.sync="milestoneDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form :model="milestoneForm" label-width="100px">
          <el-form-item label="年份">
            <el-input v-model="milestoneForm.year" type="number" placeholder="请输入年份" />
          </el-form-item>
          <el-form-item label="月份">
            <el-input v-model="milestoneForm.month" type="number" placeholder="请输入月份" />
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="milestoneForm.title" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="里程碑">
            <el-input v-model="milestoneForm.content" type="textarea" placeholder="请输入里程碑内容" />
          </el-form-item>
          <el-form-item label="语言">
            <el-select v-model="milestoneForm.language_id" placeholder="请选择语言">
              <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose(function(){ milestoneDialogVisible = false })">取消</el-button>
          <el-button type="primary" @click="handleSaveMilestone">确定</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else>
      <van-popup
        v-model="milestoneDialogVisible"
        position="bottom"
        :round="true"
        :style="{ height: '80%' }"
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <h3>{{ milestoneDialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <van-form @submit="handleSaveMilestone">
            <van-field
              v-model="milestoneForm.year"
              label="年份"
              placeholder="请输入年份"
              type="number"
            />
            <van-field
              v-model="milestoneForm.month"
              label="月份"
              placeholder="请输入月份"
              type="number"
            />
            <van-field
              v-model="milestoneForm.title"
              label="标题"
              placeholder="请输入标题"
            />
            <van-field
              v-model="milestoneForm.content"
              label="里程碑"
              placeholder="请输入里程碑内容"
              type="textarea"
              :rows="3"
            />
            <van-field label="语言">
              <van-picker
                v-model="milestoneForm.language_id"
                :columns="languageColumns"
                show-toolbar
                title="选择语言"
              />
            </van-field>
            <van-button type="primary" native-type="submit" block>确定</van-button>
            <van-button type="default" block @click="handleClosePopup">取消</van-button>
          </van-form>
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import { getProcessByLang, getProcess, addProcess, updateProcess, deleteProcess } from '@/api/website'
import { Dialog } from 'vant'

export default {
  name: 'MilestonePage',
  data() {
    return {
      isDesktop: true,
      languageList: [],
      currentLang: 'zh',
      milestoneDialogVisible: false,
      milestoneDialogTitle: '',
      milestoneForm: {
        id: null,
        year: '',
        month: '',
        day: '',
        title: '',
        content: '',
        language_id: ''
      },
      milestoneList: [
        
      ]
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
    this.getMilestoneList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  computed: {
    filteredMilestoneList() {
      return this.milestoneList.filter(item => item.lang === this.currentLang)
    },
    languageColumns() {
      return this.languageList.map(item => ({
        text: item.name,
        value: item.id
      }))
    }
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    getMilestoneList() {
      getProcessByLang(this.currentLang).then(res => {
        if(res.code === 200){
          this.milestoneList = res.data || []
        }
      })
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    handleAddMilestone() {
      this.milestoneDialogTitle = '添加发展历程'
      this.milestoneForm = {
        id: 0,
        year: '',
        month: '',
        day: '',
        title: '',
        content: '',
        language_id: ''
      }
      this.milestoneDialogVisible = true
    },
    handleEditMilestone(item) {
      this.milestoneDialogTitle = '编辑发展历程'
      this.milestoneForm = {
        id: item.id,
        year: item.year,
        month: item.month,
        day: item.day,
        title: item.title,
        content: item.content,
        language_id: item.language_id
      }
      this.milestoneDialogVisible = true
    },
    handleStatusChange(item) {
      updateProcess(item.id, { status: item.status }).then(() => {
        this.$message.success('状态更新成功')
      })
    },
    handleDeleteMilestone(id) {
      this.$confirm('确定要删除吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteProcess(id).then(() => {
          this.getMilestoneList()
          this.$message.success('删除成功')
        })
      }).catch(() => {})
    },
    resetForm() {
      this.milestoneForm = {
        id: 0,
        year: '',
        month: '',
        day: '',
        title: '',
        content: '',
        language_id: ''
      }
    },
    handleSaveMilestone() {
      // 验证表单
      if (!this.milestoneForm.year || !this.milestoneForm.month  || !this.milestoneForm.content || !this.milestoneForm.language_id) {
        this.$message.error('请填写完整信息')
        return
      }
      
      // 构建日期字符串
      
      // 获取语言代码
      const language = this.languageList.find(item => item.id === this.milestoneForm.language_id)
      const lang = language ? language.code : 'zh'
      
      const formData = {
        ...this.milestoneForm,
        lang
      }
      
      if (formData.id) {
        // 编辑
        updateProcess(formData.id,formData).then(() => {
          this.getMilestoneList()
          this.$message.success('保存成功')
          this.resetForm()
          this.milestoneDialogVisible = false
        })
      } else {
        // 添加
        addProcess(formData).then(() => {
          this.getMilestoneList()
          this.$message.success('添加成功')
          this.milestoneDialogVisible = false
        })
      }
    },
    handleLangChange() {
      // 语言切换逻辑
      this.getMilestoneList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.milestoneDialogVisible = false
      }).catch(function() {})
    }
  }
}
</script>

<style scoped lang="scss">
.milestone-page {
  width: 100%;
  padding: 20px;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.top-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content-container {
  min-height: 400px;
}

.intro-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f2f5;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.card-content {
  margin-bottom: 15px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  background-color: #f5f7fa;
  border-radius: 8px;
}

/* 移动端里程碑列表 */
.mobile-milestone-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-milestone-item {
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.mobile-milestone-date {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.mobile-milestone-content {
  font-size: 14px;
  line-height: 1.5;
  color: #606266;
  margin-bottom: 10px;
}

.mobile-milestone-actions {
  display: flex;
  gap: 10px;
}

/* 移动端弹出框样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.popup-content {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .milestone-page {
    padding: 10px;
  }
  
  .top-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .intro-card {
    padding: 15px;
  }
}
</style>